<template>
<transition name="burger-fade">
    <portal to="modal">
  <div class="age-gate" v-if="!this.$store.state.main.ageVerified" :class="{verified:  local_storage.getItem('ageVerified')}">
      <div class="inner" v-if="!local_storage.getItem('ageVerified')">
          <div class="ag-svg" v-html="contentData.data.list[0].svg"></div>
    <div class="text-block">
        <span class="f-34 bold-italic q">{{contentData.data.list[0].title}}</span>
        <div class="ac" v-html="contentData.data.list[0].teaser"></div>
        <div class="yes-or-no">
            <div class="yes" @click.once="yes">
                <span class="f-30">{{$fn.tr('კი')}}</span>
            </div>
            <div class="no" @click="$router.go(-1)">
                <span class="f-30">{{$fn.tr('არა')}}</span>
            </div>
        </div>
    </div>
    
      </div>
      <div class="lang">
        <router-link :to="this.$store.state.main.selected_menu_locales.ge" class="pointer bold f-16" :class="{active: $route.name === 'ge'}" >GEO</router-link>
        <router-link :to="this.$store.state.main.selected_menu_locales.en" class="pointer bold f-16" :class="{active: $route.name === 'en'}" >ENG</router-link>
    </div>
  </div>
  </portal>
  </transition>
</template>

<script>
export default {
    props: ['contentData'],
    data(){
        return{
              ageVerified: false,  
              local_storage: localStorage,
        }
    },
mounted(){
    
    
    if(!localStorage.getItem('ageVerified')){
        // console.log("Doesn't exist")
        this.$store.state.main.ageVerified = false;
    } else {
       this.$store.state.main.ageVerified = true;
        
    }
},
methods: {
    yes(){
    
        localStorage.setItem('ageVerified', true);
        this.$store.state.main.ageVerified = true;
    }
}
}
</script>

<style scoped lang="scss">
.ac{
    &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
       color: white;
     font-family: "FiraGO-Italic";
   }
   &::v-deep a{
       font-family: "FiraGO-BoldItalic";
   }
}
</style>